var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactsLine = function SvgContactsLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.8 7.502h4.5v1.8h-4.5zm-1.8 4.5h6.3v1.8H17zm2.7 4.5h3.6v1.8h-3.6zm-16.2 4.5a7.2 7.2 0 1 1 14.4 0h-1.8a5.4 5.4 0 1 0-10.8 0zm7.2-8.1a5.4 5.4 0 0 1-5.4-5.4c0-2.984 2.417-5.4 5.4-5.4s5.4 2.416 5.4 5.4a5.4 5.4 0 0 1-5.4 5.4m0-1.8c1.989 0 3.6-1.611 3.6-3.6s-1.611-3.6-3.6-3.6a3.6 3.6 0 0 0-3.6 3.6c0 1.989 1.611 3.6 3.6 3.6"
  })));
};
export default SvgContactsLine;